// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NmUi","footer":"styles_footer__ypZqp","passCodeTooltip":"styles_passCodeTooltip__OPsQw"};